import { Modal } from "antd"
import { useSessionStore } from "@/hooks/useStore"

const isEmptyObject = (obj) => {
    return Object.keys(obj).length === 0 && obj.constructor === Object
}

const download = (url) => {
    // 创建一个隐藏的 <a> 元素
    const link = document.createElement("a")
    link.setAttribute("target", "_blank")
    link.style.display = "none"
    link.href = url

    // 设置下载的文件名（可选）
    // link.download = "filename";

    // 将 <a> 元素添加到页面中
    document.body.appendChild(link)

    // 触发下载
    link.click()

    // 清理并移除 <a> 元素
    document.body.removeChild(link)
}
export function isMobile() {
    const userAgent = navigator.userAgent.toLowerCase()
    if (/mobile|android|iphone|ipad|phone/i.test(userAgent)) {
        return true
    } else {
        return false
    }
}
export const getUrlParam = (variable) => {
    const query = window.location.search.substring(1)
    const vars = query.split("&")
    for (let i = 0; i < vars.length; i++) {
        const pair = vars[i].split("=")
        if (pair[0] == variable) {
            return pair[1]
        }
    }
    return void 0
}
export const getHashUrlParam = (variable) => {
    const hash = window.location.hash.split("?")[1]
    const result = hash?.split("&")?.reduce(function (res, item) {
        const parts = item.split("=")
        res[parts[0]] = parts[1]
        return res
    }, {})
    return variable ? result?.[variable] : result
}
const confirmLinkJump = (
    e,
    url,
    title
) => {
    useSessionStore.set("jumpLink", true)
    if (!url.includes(location.hostname)) {
        e.preventDefault()
        Modal.info({
            title,
            width: 460,
            onOk() {
                window.open(url)
            },
            wrapClassName: "link-jump-wrap",
            okText: "继续访问",
            cancelText: "取消",
            bodyStyle: {
                background: "#f2f6ff",
                border: "1px solid #7994d7",
                borderRadius: "12px",
            },
            okButtonProps: { style: { background: "#567fe6" } },
            cancelButtonProps: { type: "text" },
            mask: false,
            centered: true,
            maskClosable: true,
            okCancel: true,
        })
    }
}

export const getChatUrl = (id, embed, isSingle) => {
    return id ? `/?znwdId=${id ?? ""}${embed ? '&embed=1' : ''}${isSingle ? "#/single" : ""}` : "./"
}

export { isEmptyObject, download, confirmLinkJump }
